export default __webpack_public_path__ + "assets/images/591c4ea4fe4159b0a684783aaab3399a.mp3";